import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { docPageModes } from '~/types';
import { useEffect, useState } from 'react';
import { useDocumentCache } from '~/atoms/document/useDocumentCache';

const routeApi = getRouteApi('/_authLayout/portfolio-company/$portfolioId');
/**
 * utility hook to simplify the handling of the documents url params for the portfolio page
 */
export const useDocumentsUrlParamsPortfolio = () => {
  const navigate = useNavigate({});
  const { mode, docId, docIds } = routeApi.useSearch<{
    mode: docPageModes;
    docId?: string;
    docIds?: string[];
  }>();
  const [isDocumentOverviewDialogVisible, setIsDocumentOverviewDialogVisible] =
    useState<boolean>(false);
  const [isDocumentCompareDialogVisible, setIsDocumentCompareDialogVisible] =
    useState<boolean>(false);
  const [activeDocumentId, setActiveDocumentId] = useState<
    string | undefined
  >();
  const [activeDocumentName, setActiveDocumentName] = useState<
    string | undefined
  >();
  const { getDocument } = useDocumentCache();
  const showDocumentOverview = (documentId: string) => {
    navigate({
      from: '/portfolio-company/$portfolioId',
      search: () => ({
        mode: 'docOverview' as docPageModes,
        docId: documentId,
      }),
    });
  };
  const showDocumentsCompare = () => {
    navigate({
      from: '/portfolio-company/$portfolioId',
      search: () => ({
        mode: 'docCompare' as docPageModes,
        docId: undefined,
      }),
    });
  };
  const hideDocumentOverview = () => {
    navigate({
      from: '/portfolio-company/$portfolioId',
      search: () => ({
        mode: 'table' as docPageModes,
        docId: undefined,
      }),
    });
  };
  const hideDocumentCompare = () => {
    navigate({
      from: '/portfolio-company/$portfolioId',
      search: () => ({
        mode: 'table' as docPageModes,
        docId: undefined,
      }),
    });
  };

  useEffect(() => {
    if (mode === 'docOverview' && docId) {
      setIsDocumentOverviewDialogVisible(true);
      setActiveDocumentId(docId);
      if (docId) {
        getDocument(docId).then((doc) => {
          setActiveDocumentName(doc?.originalName);
        });
      }
    }
    if (mode === 'table') {
      setIsDocumentOverviewDialogVisible(false);
      setIsDocumentCompareDialogVisible(false);
    }
    if (mode === 'docCompare') {
      setIsDocumentOverviewDialogVisible(false);
      setIsDocumentCompareDialogVisible(true);
    }
  }, [mode, docId, docIds]);

  return {
    isDocumentOverviewDialogVisible,
    isDocumentCompareDialogVisible,
    showDocumentOverview,
    activeDocumentId,
    activeDocumentName,
    hideDocumentOverview,
    hideDocumentCompare,
    showDocumentsCompare,
  };
};
